import { generateEventParams } from './events';

const sendMessage = ({ contact, content, conversationId, ticketTypeId, ticketTypeFields, priority }) => {
  const referrerURL = window.referrerURL || '';

  return {
    url: `/api/widget/messages`,
    params: {
      contact,
      message: {
        content,
        timestamp: new Date().toString(),
        referer_url: referrerURL,
      },
      conversation_id: conversationId,
      ticketTypeId,
      ticketTypeFields,
      priority,
    },
  };
};

const sendAttachment = ({ attachment, conversationId }) => {
  const { referrerURL = '' } = window;
  const timestamp = new Date().toString();
  const { file } = attachment;

  const params = {
    'message[attachments][]': file,
    'message[referer_url]': referrerURL,
    'message[timestamp]': timestamp,
  };

  if (conversationId) {
    params.conversation_id = conversationId;
  }

  return {
    url: `/api/widget/messages`,
    params: params,
  };
};

const getConversation = ({ before, conversationId }) => ({
  url: `/api/widget/messages`,
  params: { before, conversation_id: conversationId },
});

const getMessage = ({ id }) => ({
  url: `/api/widget/messages/${id}`,
});

const updateMessage = id => ({
  url: `/api/widget/messages/${id}`,
});

const getAvailableAgents = token => ({
  url: `/api/widget/inbox-members`,
  params: {
    widget_id: token,
  },
});
//
const getCampaigns = token => ({
  url: `/api/widget/campaigns`,
  params: {
    widget_id: token,
  },
});

const triggerCampaign = ({ widgetId, campaignId, customAttributes }) => ({
  url: '/api/widget/events',
  data: {
    name: 'campaign.triggered',
    event_info: {
      campaign_id: campaignId,
      custom_attributes: customAttributes,
      ...generateEventParams(),
    },
  },
  params: {
    widget_id: widgetId,
  },
});

export default {
  sendMessage,
  sendAttachment,
  getConversation,
  getMessage,
  updateMessage,
  getAvailableAgents,
  getCampaigns,
  triggerCampaign,
};
